
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

//获取参数列表
export const getSystemList = () => {
    return request.get("/outpatient/system/list")
}

//获取参数列表
export const updateSystemData = (data) => {
    return request.put("/outpatient/system",data)
}

//获取参数列表
export const saveSystemData = (data) => {
    return request.post("/outpatient/system",data)
}
//快速调拨
export const fastTransfer = (data) => {
    return request.post("/outpatient/dpurcallocate/fastTransfer",data)
}


// 暴露
export default{
    getSystemList,updateSystemData,saveSystemData,fastTransfer
}